import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useMemo } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { MetaAdCampaignWizardStep } from 'components/Wizards/schemas/MetaAdCampaign'

export const useIsAdsFeatureEnabled = (): boolean => {
  const { isMobile } = useResponsiveDesign()

  const workspace = useCurrentWorkspace()
  const isAutopilot = !!workspace?.is_virtual_marketer

  const isEnabled = useMemo<boolean>(() => {
    return !isMobile && isAutopilot
  }, [isAutopilot, isMobile])

  return isEnabled
}

export const useNavigateToCampaignWizard = () => {
  const history = useHistory()
  const { url } = useRouteMatch()

  return (campaignId: number, targetStep?: MetaAdCampaignWizardStep) => {
    history.push(`${url}/wizard/${campaignId}${targetStep !== undefined ? `#${targetStep}` : ''}`)
  }
}
